export default __webpack_public_path__ + "static/media/department3.9253b9fe.png";